import { createAction, props } from '@ngrx/store';

export enum RecoverActionTypes {
	OrderSearchRecoverCredentials = '[Order Search] Set Recover Credentials',
	AutoLoginRecoverCredentials = '[AutoLogin] Set Recover Credentials',
	SetMFAToken = '[AutoLogin] Set Auth Token',
	ClearRecoveryState = '[Recovery] Clear State',
	UpdateEToken = '[Recovery] Update eToken',
	UpdateOToken = '[Recovery] Update oToken',
	UpdateCToken = '[Recovery] Update cToken',
	UpdatePToken = '[Recovery] Update pToken',
	UpdateOrderId = '[Recovery] Update Order ID',
	UpdateEmail = '[Recovery] Update Email',
	UpdateBarcode = '[Recovery] Update Barcode',
}

export enum PostVerifyAction {
	AutoLogin = 'autologin',
	Login = 'login',
	Orders = 'orders',
	ThreeDS = '3ds',
	Payments = 'payments',
}

/**
 * Called from the order lookup flow
 */
export const setOrderSearchRecoverCredentialsAction = createAction(
	RecoverActionTypes.OrderSearchRecoverCredentials,
	props<{
		payload: {
			email: string;
			phone: string;
			postVerifyAction: string;
		};
	}>()
);

/**
 * Called when were going through an autologin flow
 */
export const setAutoLoginRecoverCredentialsAction = createAction(
	RecoverActionTypes.OrderSearchRecoverCredentials,
	props<{
		payload: {
			oToken: string;
			eToken: string;
			user_token?: string;
			postVerifyAction: string;
		};
	}>()
);

/**
 * Sets the auth token for use later.
 */
export const setRecoverMFATokenAction = createAction(RecoverActionTypes.SetMFAToken, props<{ mfaToken: string }>());

/**
 * Called post login or order search to clear the state
 */
export const clearRecoverStateAction = createAction(RecoverActionTypes.ClearRecoveryState);

/**
 * Called to update eToken in Recover State from onUpdateBilling
 */
export const updateETokenAction = createAction(RecoverActionTypes.UpdateEToken, props<{ eToken: string }>());

/**
 * Called to update oToken in Recover State
 */
export const updatePTokenAction = createAction(RecoverActionTypes.UpdatePToken, props<{ pToken: string }>());

/**
 * Called to update oToken in Recover State
 */
export const updateOTokenAction = createAction(RecoverActionTypes.UpdateOToken, props<{ oToken: string }>());

/**
 * Called to update cToken in Recover State
 */
export const updateCTokenAction = createAction(RecoverActionTypes.UpdateCToken, props<{ cToken: string }>());

/**
 * Called to update Order ID in Recover State
 */
export const updateOrderIdAction = createAction(RecoverActionTypes.UpdateOrderId, props<{ order_id: string }>());

/**
 * Called to update Email in Recover State
 */
export const updateEmailAction = createAction(RecoverActionTypes.UpdateEmail, props<{ email: string }>());

/**
 * Called to update barcode in Recover State
 */
export const updateBarcodeAction = createAction(RecoverActionTypes.UpdateBarcode, props<{ barcode: string }>());
